export default "__VITE_ASSET__a5beb2d6__"